import { Fab, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AcceptanceStatusList from "./AcceptanceStatusList";

export interface SetStatusFABProps {
	onListItemClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>, val: string) => void;
	disabled?: boolean;
}

const SetStatusFAB = (props: SetStatusFABProps) => {
	const { t } = useTranslation();
	const { onListItemClick, disabled } = props;
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const { fab } = useStyles();

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleCloseOnClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, status: string) => {
		onListItemClick(e, status);
		handleClose();
	};

	return (
		<span>
			<AcceptanceStatusList
				disabled={disabled}
				onClick={handleClose}
				handleCloseOnClick={handleCloseOnClick as any}
				anchorEl={anchorEl}
			/>
			<Fab disabled={disabled} onClick={handleClick} className={fab} variant="extended">
				<AddIcon fontSize="default" /> &nbsp;{t("set-decision")}
			</Fab>
		</span>
	);
};

const useStyles = makeStyles({
	fab: {
		backgroundColor: "#367bf5",
		color: "#ffffff",
		border: "solid 1px #367bf5",
		fontWeight: "bold",
		boxShadow: "0 0.063rem 0.25rem 0 rgba(54, 123, 245, 0.6)",
		borderRadius: "1.75rem",
		"&:hover": {
			backgroundColor: "#367bf5",
		},
		"&:disabled": {
			backgroundColor: "#afcafb",
			color: "white",
			border: "none",
			boxShadow: "0 0.063rem 0.25rem 0 rgba(54, 123, 245, 0.6)",
		},
		fontSize: "0.875rem",
	},
});

export default SetStatusFAB;
